import { render, staticRenderFns } from "./AppFatHead.vue?vue&type=template&id=487aaba4&"
import script from "./AppFatHead.vue?vue&type=script&lang=js&"
export * from "./AppFatHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports